import React from 'react';

const MyorderHistory = () => {
    return (
        <div>
            <h2>Order History</h2>
        </div>
    );
};

export default MyorderHistory;